import { Group } from '@mantine/core';
import { trackEvent } from '@repo/common/analytics';
import { Button } from '@repo/foundations';
import { useAuthUser, useIntegrationPrefetched } from '../../../../../api';
import EntityDrawerBreadcrumbs from '../../../../../components/EntityDrawer/components/EntityDrawerBreadcrumbs';
import {
	NavBarBreadcrumbWrapper,
	NavBarWrapper,
} from '../../../../../components/SecodaAppShell/SecodaNavBar';
import policyIssueStore from '../store';
import { useStyles } from '../styles';
function EntityActionBar() {
	const { theme } = useStyles();
	const { user, workspace } = useAuthUser();

	const onClick = () => {
		if (!policyIssueStore.externalUrl) return;
		trackEvent(
			`${policyIssueStore.entity.entity_type}/link/click`,
			{},
			user,
			workspace!
		);
		window.open(policyIssueStore.externalUrl, '_blank', 'noopener,noreferrer');
	};

	const { data: integration } = useIntegrationPrefetched({
		id: policyIssueStore.entity.integration!,
		options: {
			enabled:
				!!policyIssueStore.entity.integration &&
				policyIssueStore.entity.integration !== 'secoda',
		},
	});

	return (
		<NavBarWrapper
			sticky={false}
			bg={theme.other.getColor('surface/primary/default')}
		>
			<NavBarBreadcrumbWrapper>
				<Group position="apart" noWrap w="100%">
					<EntityDrawerBreadcrumbs
						entity={policyIssueStore.entity}
						onClick={policyIssueStore.closeEntityDrawer}
					/>
					{policyIssueStore.externalUrl && integration && (
						<Button onClick={onClick} leftIconName="externalLink">
							Open in {integration.name}
						</Button>
					)}
				</Group>
			</NavBarBreadcrumbWrapper>
		</NavBarWrapper>
	);
}

export default EntityActionBar;
